module.exports = __webpack_public_path__ + "static/media/background.3d1a4d6b.svg";